import { Backdrop, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { PuffLoader } from 'react-spinners';
import norecord from '../../images/WarningImage/nofiles.svg';
import { IAPIDocumentHistory } from '../../models/APITransationLog/IAPITransationLog';
import { useGlobalState } from '../../store/GlobalStore';
import { useFetch } from '../../utils/apiHelper';
import useStyles from '../GlobalStyles/DocumentCss';

const APIDocumentHistory: React.FC<{ documentId?: number }> = (props) => {
    const classes = useStyles();
    const { state } = useGlobalState();
    const [ProgressBar, setShowProgressBar] = useState(false);
    const [documentHistoryList, setDocumentHistoryList] = useState<IAPIDocumentHistory[]>([]);

    useEffect(() => {
        FetchAPIDocumentHistory();
    }, [props?.documentId])

    const FetchAPIDocumentHistory = () => {
        setShowProgressBar(true);
        (async () => {
            await useFetch<any>(`History/GetAPIDocumentHistory?DocumentId=${props.documentId}`).then((result) => {
                setDocumentHistoryList(result?.data);
            })
                .finally(() => {
                    setShowProgressBar(false);
                });
        })();
    };

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        const headCells = [
            { id: "firstName", disablePadding: false, label: "FIRST NAME", sortable: false },
            { id: "lastName", disablePadding: false, label: "LAST NAME", sortable: false },
            { id: "actionTakenBy", disablePadding: false, label: "ACTION TAKEN BY", sortable: false, },
            { id: "actionName", disablePadding: false, label: "ACTION NAME", sortable: false },
            { id: "actionTakenDate", disablePadding: false, label: "ACTION TAKEN DATE", sortable: false },
        ];

        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            sortDirection={orderBy === headCell.id ? order : false}
                            className={classes.TableCellStyle}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                            >
                                <Typography variant='body2' fontSize={"12px"}>
                                    <b>{headCell?.label || headCell.sortable}</b>
                                </Typography>
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={ProgressBar}>
                <PuffLoader size={80} color={"white"} speedMultiplier={1} />
            </Backdrop>

            <TableContainer className={`${classes.containerHistory} ${"scrollbox"} ${"on-scrollbar"}`}>
                <Table size="small" aria-label="customized table" stickyHeader>
                    <EnhancedTableHead />
                    {documentHistoryList?.map((row) => (
                        <TableBody>
                            <TableRow>
                                <TableCell>{row?.firstName}</TableCell>
                                <TableCell>{row?.lastName}</TableCell>
                                <TableCell>{row?.actionTakenBy}</TableCell>
                                <TableCell>{row?.actionName}</TableCell>
                                <TableCell>
                                    {moment(row?.actionTakenDate)?.format(state?.GlobalUtils?.settingValue)}{" "}
                                    {moment(row?.actionTakenDate).format("HH:mm")}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    ))}
                </Table>

                {!documentHistoryList?.length ?
                    <Stack p={0} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                        <div className={classes.noRecordsColor}>
                            <img src={norecord} alt="Icon for no document to display" width="60px" height="60px" />
                        </div>
                        <Typography variant='h6' fontSize={'14px'} align='center' className={classes.noFiles} pt={"5px"}>
                            No API Documents History to display..
                        </Typography>
                    </Stack>
                    : null}
            </TableContainer>

        </React.Fragment>
    )
}

export default APIDocumentHistory